__webpack_require__.p = "/views-skeletons/account-setup/";